<div class="card-locker-map">
    <div class="google_map" #google_map></div>
</div>